import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "./hooks/useLenis";
import LandingPage from "./components/landing/LandingPage";
import CookieBanner from "./components/landing/CookieBanner";
import EmpresaPage from "./components/pages/EmpresaPage";
import EmpresaRegistroPage from "./components/pages/EmpresaRegistroPage";
import AdvisorPage from "./components/pages/AdvisorPage";
import AdvisorRegistroPage from "./components/pages/AdvisorRegistroPage";
import ProtocoloPage from "./components/pages/ProtocoloPage";
import AdminPage from "./components/pages/AdminPage";
import AvisoLegalPage from "./components/pages/AvisoLegalPage";
import PrivacidadPage from "./components/pages/PrivacidadPage";
import TerminosPage from "./components/pages/TerminosPage";
import CookiesPage from "./components/pages/CookiesPage";

function App() {
  useLenis();

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/empresa" element={<EmpresaPage />} />
          <Route path="/empresa/registro" element={<EmpresaRegistroPage />} />
          <Route path="/advisor" element={<AdvisorPage />} />
          <Route path="/advisor/registro" element={<AdvisorRegistroPage />} />
          <Route path="/protocolo" element={<ProtocoloPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/legal" element={<AvisoLegalPage />} />
          <Route path="/privacidad" element={<PrivacidadPage />} />
          <Route path="/terminos" element={<TerminosPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
